import { toast } from "sonner";

// Opens the existing Tawk.to live-chat widget (loaded by TawkChat.jsx).
// Does not fall back to any email, chat is the only support channel.
export const openLiveChat = () => {
  const api = typeof window !== "undefined" ? window.Tawk_API : null;
  if (api && typeof api.maximize === "function") {
    try {
      api.maximize();
      return;
    } catch (e) {
      /* fall through to toast */
    }
  }
  toast("Live chat is loading…", {
    description: "One moment, if it doesn't open, please try again in a few seconds.",
  });
};
